import React, { useEffect, useState } from 'react';
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { useDispatch, useSelector } from "react-redux";
import { addPaymentRecord,updatePayment } from '../actions/paymentRecordActions';


export const AddPaymentRecord = ({ closePopup, studentId, payment }) => {

    const enrollmentsArray = useSelector((state) =>
        state.enrollments ? state.enrollments : null);
    const studentsArray = useSelector((state) =>
        state.students ? state.students : null);
    const paymentRecordsArray = useSelector((state) =>
        state.paymentRecords ? state.paymentRecords : null);
    const studentSelected = useSelector((state) =>
        state.selection.selectedStudent ? state.selection.selectedStudent : null);

    const [selectedStudent, setSelectedStudent] = useState("");
    const [paymentAmount, setPaymentAmount] = useState("");
    const [currency, setCurrency] = useState("UYU");
    const currencies = ['UYU', 'ARG', 'USD'];


    const dispatch = useDispatch();


    useEffect(() => {
        if (payment) {
            setSelectedStudent(payment.student);
            setPaymentAmount(payment.amount);
            setCurrency(payment.currency);
        } else {
            if (studentSelected) {
                setSelectedStudent(studentSelected);
            } else {
                const avaiableStudents = studentsArray?.filter(st =>
                    !enrollmentsArray.some(enrollment =>
                        enrollment.student?._id === st?._id
                    )
                )
                const selectedStudent = avaiableStudents[0];
                setSelectedStudent(selectedStudent);
            }
        }
    }, []);


    const handleStudentChange = (e) => {
        const selectedStudentId = e.target.value;
        const selectedStudent = studentsArray.find(st => st._id === selectedStudentId);
        setSelectedStudent(selectedStudent);
    };
    const handleSave = async () => {
        if (payment) { 
            const input = {
                paymentRecordId: payment._id,
                studentId: selectedStudent._id,
                amount: parseFloat(paymentAmount),
                currency:currency,
            };
            dispatch(updatePayment(input));
        } else {
            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0];
            const input = {
                studentId: selectedStudent._id,
                paymentDate: formattedDate,
                amount: parseFloat(paymentAmount),
                currency:currency,
            };
            dispatch(addPaymentRecord(input));
        }
    };

    return (
        <FormWrapper>

            <Label>
                Student:
                <Select
                    value={selectedStudent?._id}
                    onChange={(e) => { handleStudentChange(e) }}
                >
                    {studentsArray.map((student, index) => (
                        <option key={index} value={student._id}>{student.name}</option>
                    ))}
                </Select>
            </Label>
            <Label>
                Currency:
                <Select
                    value={currency}
                    onChange={(e) => setCurrency(e.target.value)}
                >
                    {currencies.map((item, index) => (
                        <option key={index} value={item}>{item}</option>
                    ))}
                </Select>
            </Label>
            <Label>
                Amount:
                <Input
                    type="text"
                    name="grade"
                    value={paymentAmount}
                    placeholder='0'
                    onChange={(e) => { setPaymentAmount(e.target.value) }}
                />
            </Label>
            <Button onClick={() => handleSave()}>Save</Button>
        </FormWrapper>
    );
};


export default AddPaymentRecord;
